module.exports = __webpack_public_path__ + "img/activities-24.28b51771.jpg";